import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from "../../../hooks/useAuth";//hooks/useAuth
import {
  selectPublicMenus,
  selectProtectedMenus
} from '../../../store/slices/database/menuConfigSlice';//store/slices/database/menuConfigSlice

// Import templates
import { getTemplate, getTemplatePosition } from './templates';
import MobileDrawer from './MobileDrawer';

const Navbar = ({ template = 'default', isMobile = false, mobileOpen = false, onMobileClose, anchor = 'left' }) => {
  const navigate = useNavigate();
  const keycloakAuth = useAuth();

  const publicMenus = useSelector(selectPublicMenus);
  const protectedMenus = useSelector(selectProtectedMenus);

  // The logged-in menu is complete (anonymous + authenticated + authorized items), so once a
  // company's menu is loaded it replaces the public one. Before that - logged out, or logged in
  // but no company picked yet - the public menu is shown.
  const protectedMenuLoaded = useSelector((state) => state.menuConfig?.data?.protected != null);
  const menus = keycloakAuth.isAuthenticated && protectedMenuLoaded ? protectedMenus : publicMenus;

  const handleItemClick = (item) => {
    if (item.to) {
      navigate(item.to);
      if (isMobile && onMobileClose) {
        onMobileClose();
      }
    }
  };

  if (isMobile) {
    return (
      <MobileDrawer
        open={mobileOpen}
        onClose={onMobileClose}
        anchor={anchor}
        items={menus?.filter(item => !item.parentId && item.active)}
        flatNavigationItems={menus?.filter(item => item.active)}
        onItemClick={handleItemClick}
      />
    );
  }

  // Get the template component dynamically
  const TemplateComponent = getTemplate(template);

  return (
    <TemplateComponent
      items={menus?.filter(item => !item.parentId && item.active)}
      onItemClick={handleItemClick}
      flatNavigationItems={menus?.filter(item => item.active)}
    />
  );
};

// Export helper function to get position
export const getNavbarPosition = (template) => {
  return getTemplatePosition(template);
};

export default Navbar;
